export default __webpack_public_path__ + "static/Entenda0014-36525a1622983ecef09acc8efbcc1f7f.jpg";